import { render, staticRenderFns } from "./RechargeConfig.vue?vue&type=template&id=04505244&scoped=true"
import script from "./RechargeConfig.vue?vue&type=script&lang=js"
export * from "./RechargeConfig.vue?vue&type=script&lang=js"
import style0 from "./RechargeConfig.vue?vue&type=style&index=0&id=04505244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04505244",
  null
  
)

export default component.exports